import React from 'react';
import { Platform, StyleSheet, View } from 'react-native';
import { Text } from 'react-native-paper';
import { MaterialCommunityIcons } from '@expo/vector-icons';
import { useTranslation } from 'react-i18next';

import AdBanner from '../components/AdBanner';
import ResumeListScreen from '../components/resume/ResumeListScreen';
import { spacing, useThemePalette } from '../theme';

export const metadata = {
  title: 'Resume Builder — Create & Export Professional Resumes | RemoteWork',
  description:
    'Build, save, and export multiple resumes as PDF or DOCX. Three professional templates: Modern, Classic, and Minimal.',
  keywords:
    'resume builder, cv builder, pdf resume, docx resume, free resume templates, remote work resume',
};

export default function ResumeBuilderScreen() {
  const { t } = useTranslation();
  const palette = useThemePalette();

  if (Platform.OS === 'web') {
    return (
      <View
        style={[styles.placeholder, { backgroundColor: palette.canvas }]}
      >
        <MaterialCommunityIcons
          name="cellphone-text"
          size={64}
          color={palette.textMuted}
        />
        <Text style={[styles.placeholderTitle, { color: palette.textPrimary }]}>
          {t('resume.webPlaceholder.title')}
        </Text>
        <Text
          style={[styles.placeholderSubtitle, { color: palette.textSecondary }]}
        >
          {t('resume.webPlaceholder.subtitle')}
        </Text>
      </View>
    );
  }

  return (
    <View style={[styles.container, { backgroundColor: palette.canvas }]}>
      <ResumeListScreen />
      <AdBanner />
    </View>
  );
}

const styles = StyleSheet.create({
  container: { flex: 1 },
  placeholder: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: spacing.xl,
    gap: spacing.md,
  },
  placeholderTitle: {
    fontSize: 20,
    fontWeight: '700',
    textAlign: 'center',
    marginTop: spacing.sm,
  },
  placeholderSubtitle: {
    fontSize: 14,
    textAlign: 'center',
    lineHeight: 20,
  },
});
